import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'capitalize',
})
export class CapitalizePipe implements PipeTransform {
  transform(value: any) {
    if (value) {
      const words = value.split(' ');
      value = words.map((word) => word.substring(0, 1).toUpperCase() + word.substring(1, word.length).toLowerCase()).join(' ');
      //console.log('capUpperCase: ' + value);
      return value;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/capitalize/capitalize.ts